module.exports = __webpack_public_path__ + "img/cloud-slash-fill.99bd831e.svg";